<script>
    import { createEventDispatcher } from 'svelte';
    import Select from 'svelte-select'

    import { isEmpty } from 'src/utils/forms';

    export let items;
    export let value = undefined;
    export let placeholder = 'Select value...';

    let label = undefined;

    const handleSelect = ({ detail }) => {
        value = isEmpty(detail?.value) ? undefined : detail.value;
        label = detail && detail.label || undefined;
        dispatch('change', value);
    }

    const handleClear = () => {
        value = undefined;
        label = undefined;
        dispatch('change', value);
        dispatch('clear');
    };

    const dispatch = createEventDispatcher();

    $: selectedValue = !isEmpty(value) && { value, label } || undefined;
</script>

<div class="select-field">
    <Select
        {items}
        {selectedValue}
        {placeholder}
        on:select={handleSelect}
        on:clear={handleClear}
        {...$$restProps}
    />
</div>

<style>
    :global(.select-field) {
        --border: 2px solid #ddd;
        --borderRadius: 3px;
        --borderFocusColor: black;
        --placeholderColor: #bbb;
        --height: 40px;
        width: 100%;
    }

    :global(.select-field input) {
        margin-bottom: 0;
    }
</style>
